import axios from "axios";
import localStorageService from "../services/localStorageService";

axios.interceptors.request.use(
  function(config) {
    if (!config.headers) config.headers = {};

    // if (!config.headers["Content-Type"]) {
    //   config.headers.Accept = "application/json";
    //   config.headers["Content-Type"] = "application/json";
    // }

    let token = localStorageService.getAccessToken();
    config.headers.Authorization = token ? `Bearer ${token}` : undefined;

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    return response.status >= 200 && response.status <= 299
      ? response.data.result ?? response.data ?? response ?? null
      : Promise.reject(response.data);
  },
  function(error) {
    console.warn(error);
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const token = localStorageService.getRefreshToken();

      return new Promise((resolve, reject) => {
        axios
          .post("/api/auth/refresh-token", {
            token,
          })
          .then((token) => {
            localStorageService.setToken(token);

            axios.defaults.headers.common["Authorization"] =
              "Bearer " + localStorageService.getAccessToken();

            axios(originalRequest).then(resolve, reject);
          }, reject);
      });
    } else return Promise.reject(error.response.data);
  }
);
